import {
  Pagination as CWPagination,
  Center,
  Spacer,
  Spacings,
} from "@polestar/component-warehouse-react";
import { Form, useSubmit } from "@remix-run/react";

interface Props {
  readonly currentPage: number;
  readonly pageCount: number;
  readonly newsTagId?: string;
  readonly nextButtonAriaLabel: string;
  readonly previousButtonAriaLabel: string;
  readonly goToPageAriaLabel: string;
}

const Pagination = ({
  currentPage,
  pageCount,
  newsTagId,
  nextButtonAriaLabel,
  previousButtonAriaLabel,
  goToPageAriaLabel,
}: Props) => {
  const submit = useSubmit();

  return (
    <Center>
      <Spacer
        spacing={{
          mobile: Spacings.xLarge,
          tablet: Spacings.none,
          desktop: Spacings.none,
          desktopWide: Spacings.none,
        }}
      />
      <Form method="get">
        <CWPagination
          activeIndex={currentPage}
          maxIndex={pageCount}
          nextButtonProps={{
            "aria-label": nextButtonAriaLabel,
          }}
          previousButtonProps={{
            "aria-label": previousButtonAriaLabel,
          }}
          indexAriaLabel={({ index }) => {
            return `${goToPageAriaLabel} ${index ?? 0}`;
          }}
          onChange={(pageNumber) => {
            const page = String(pageNumber);

            submit(
              new URLSearchParams(
                newsTagId ? { tag: newsTagId, page } : { page }
              )
            );

            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        />
      </Form>
    </Center>
  );
};

export default Pagination;
